import React, { useState, useEffect } from "react";
import {
  Table,
  Button,
  Modal,
  Input,
  Tag,
  Select,
  Skeleton,
  Tooltip,
} from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import { useSelector, useDispatch } from "react-redux";
import StatisticWidget from "../../components/shared-components/StatisticWidget";

import "./Staff.scss";
import { addAdmin } from "../../features/staff/staffThunk";
import { allUsers } from "../../features/user/userThunk";
import AdminDetailsDrawer from "./AdminDetailsDrawer";
import { ADMIN_TYPES, SECTION_TAGS } from "./adminTypes";

const Staff = () => {
  const dispatch = useDispatch();
  const { users, usersLoader } = useSelector((state) => state.user);
  const currentAdmin = useSelector((state) => state.auth.admin);
  const [detailsAdminId, setDetailsAdminId] = useState(null);
  const staff = users?.admins;
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [email, setEmail] = useState("");
  const [first_name, setFirst_name] = useState("");
  const [last_name, setLast_name] = useState("");
  const [adminType, setAdminType] = useState("");
  const { Option } = Select;
  useEffect(() => {
    dispatch(allUsers());
  }, [dispatch]);
  useEffect(() => {
    setIData(staff);
  }, [users, staff]);
  const [idata, setIData] = useState(staff);

  const searchTerm = (term) => {
    // const result = data.filter((item) => item.order_id === orderId);
    const result = staff.filter((item) => {
      return Object.values(item)
        .join("")
        .toLowerCase()
        .includes(term.toLowerCase());
    });
    if (result) {
      setIData(result);
    } else {
      setIData(staff);
    }

    console.log(result);
  };
  const dat = {
    email,
    firstName: first_name,
    lastName: last_name,
    adminType,
  };

  const onChange = (value) => {
    setAdminType(value);
  };
  const onSearch = (value) => {
    console.log("search:", value);
  };

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    dispatch(addAdmin(dat));
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };
  const columns = [
    {
      title: "ID",
      dataIndex: "_id",
      key: "_id",
      render: (text) => <p>{text}</p>,
    },
    {
      title: "First Name",
      dataIndex: "firstName",
      key: "firstName",
      render: (text) => <p>{text}</p>,
    },
    {
      title: "Last Name",
      dataIndex: "lastName",
      key: "lastName",
      render: (text) => <p>{text}</p>,
    },
    {
      title: "Email Adress",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Role",
      dataIndex: "admin_section_id",
      key: "admin_section_id",
      render: (_, { admin_section_id }) => {
        const tag = SECTION_TAGS[admin_section_id];
        return tag ? <Tag color={tag.color}>{tag.label}</Tag> : null;
      },
    },
    {
      title: "Status",
      dataIndex: "disabled",
      key: "disabled",
      render: (disabled) => (
        <>
          {disabled ? (
            <Tag color="red">DISABLED</Tag>
          ) : (
            <Tag color="green">ACTIVE</Tag>
          )}
        </>
      ),
    },

    {
      title: "Details",
      key: "details",
      align: "center",
      render: (_, record) => (
        <Tooltip title="View and manage account">
          <Button
            type="text"
            aria-label={`Manage ${record.firstName} ${record.lastName}`}
            icon={<InfoCircleOutlined />}
            onClick={() => setDetailsAdminId(record._id)}
          />
        </Tooltip>
      ),
    },
  ];
  return (
    <div className="home">
      <Sidebar />
      <div className="homeContainer">
        <Navbar />
        <Modal
          title="Add a new Staff"
          visible={isModalVisible}
          onOk={handleOk}
          onCancel={handleCancel}
        >
          <Input
            placeholder="Tramango Email"
            onChange={(e) => setEmail(e.target.value)}
          />
          <Input
            placeholder="First Name"
            onChange={(e) => setFirst_name(e.target.value)}
          />
          <Input
            placeholder="Last Name"
            onChange={(e) => setLast_name(e.target.value)}
          />

          <Select
            showSearch
            placeholder="Select Admin type"
            optionFilterProp="children"
            onChange={onChange}
            onSearch={onSearch}
            filterOption={(input, option) =>
              option.children.toLowerCase().includes(input.toLowerCase())
            }
          >
            {ADMIN_TYPES.map(({ value, label }) => (
              <Option key={value} value={value}>
                {label}
              </Option>
            ))}
          </Select>
        </Modal>
        <AdminDetailsDrawer
          adminId={detailsAdminId}
          currentAdminId={currentAdmin?._id}
          onClose={() => setDetailsAdminId(null)}
          onChanged={() => dispatch(allUsers())}
        />
        <div className="widgets"></div>
        <div className="statTile">
          <StatisticWidget
            title="Total Number of Staff"
            value={staff?.length}
            status={8.8}
            subtitle="Past 30 days"
            isLoading={usersLoader}
          />
        </div>
        <div className="charts"></div>
        <div className="listContainer">
          <div className="card-header">
            <div className="listTitle">Staffs</div>
            <Button onClick={showModal} type="primary">
              Add staff
            </Button>
          </div>

          <input
            className="pageSearch"
            type="text"
            placeholder="Search Staffs"
            onChange={(e) => searchTerm(e.target.value)}
          />
          {usersLoader ? (
            <Skeleton active />
          ) : (
            <Table columns={columns} dataSource={idata} />
          )}
        </div>
      </div>
    </div>
  );
};

export default Staff;
